import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'

import PlacowkaService from '@/services/PlacowkaService'
import { TRIAGE_OPTIONS, getTriageOption } from '../common/triageCategories'

export default function KategoriaKlienta({ clientId, initialTriage }) {
	const [triage, setTriage] = useState(initialTriage ?? '')
	const [saving, setSaving] = useState(false)

	useEffect(() => {
		setTriage(initialTriage ?? '')
	}, [clientId, initialTriage])

	const currentOption = getTriageOption(triage)
	const selectValue = currentOption ? String(currentOption.value) : ''

	const handleChange = async event => {
		const nextTriage = Number(event.target.value)
		if (!clientId || Number.isNaN(nextTriage) || nextTriage === Number(triage)) return

		const previousTriage = triage
		setTriage(nextTriage)
		setSaving(true)

		const result = await PlacowkaService.updateTriage(clientId, nextTriage)
		setSaving(false)

		if (!result?.success) {
			setTriage(previousTriage)
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zaktualizowac kategorii klienta',
				icon: 'error',
			})
		}
	}

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm lg:min-w-[240px]">
			<h2 className="text-xs font-medium uppercase tracking-wide text-gray-500">Kategoria klienta</h2>
			<div className="mt-3 flex flex-col gap-3">
				{currentOption ? (
					<span
						className={`inline-flex w-fit items-center rounded-full px-3 py-1 text-sm font-medium ${currentOption.colorClass}`}>
						{currentOption.label}
					</span>
				) : (
					<span className="text-sm text-gray-500">Brak kategorii</span>
				)}
				<label className="flex flex-col gap-1.5 text-sm text-gray-700">
					<span className="font-medium">Zmien kategorie</span>
					<select
						value={selectValue}
						onChange={handleChange}
						disabled={!clientId || saving}
						className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60">
						<option value="" disabled>
							Wybierz kategorie
						</option>
						{TRIAGE_OPTIONS.map(option => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
				</label>
			</div>
		</div>
	)
}
